module.exports = __webpack_public_path__ + "img/CardImage11.f4b496ad.png";